module.exports = new __parcel__URL__("arrow-left-circle.82d83f2c.svg").toString();